import { useQuery } from '@tanstack/react-query';
import { getTags } from '../../api/apiTags';

/**
 * Hook to fetch all active tags for select components
 */
export const useGetTagsForSelect = () => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['tags-select'],
        queryFn: () => getTags({ per_page: 100, is_active: 1 }),
        retry: false,
    });

    return {
        options: data?.data || [],
        isLoading,
        error
    };
};
